import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoneyCircle16Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconMoneyCircle16Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m.5-10.9a.5.5 0 1 0-1 0v.307c-.444.054-.825.18-1.12.415-.447.357-.59.873-.59 1.413 0 .655.338 1.107.76 1.421.394.294.902.496 1.331.667l.008.003c.465.185.846.338 1.12.533.251.18.348.347.348.567 0 .347-.168.604-.45.795a1.97 1.97 0 0 1-1.055.304c-.489 0-.807-.172-1.003-.332a1.3 1.3 0 0 1-.267-.296.5.5 0 0 0-.88.473l.441-.234-.442.235.001.001.001.002.004.006.008.016.027.044q.034.055.096.138c.083.109.207.25.379.39.292.238.714.468 1.283.537v.394a.5.5 0 0 0 1 0v-.445a2.8 2.8 0 0 0 .965-.404c.5-.336.892-.879.892-1.624 0-.645-.349-1.082-.767-1.38-.377-.27-.86-.462-1.275-.627l-.056-.022c-.46-.183-.84-.34-1.112-.543-.248-.184-.356-.367-.356-.62 0-.37.093-.534.213-.63.15-.119.457-.23 1.085-.23.538 0 .87.18 1.065.34a1.2 1.2 0 0 1 .252.28l.005.01a.5.5 0 0 0 .895-.446l-.449.22.449-.22v-.002l-.002-.002-.003-.007-.009-.016a1.4 1.4 0 0 0-.121-.19 2.2 2.2 0 0 0-.384-.402A2.5 2.5 0 0 0 8.5 4.4zm.911 1.905v-.001m-3.268 4.131.442-.234z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoneyCircle16Filled);
